require('./bootstrap');
import './common/_noduplicate';
import './common/_clickAwd';
import './common/_clickUserAgreement';
